(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["dj-how-to-use"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__djHowtoInit) return;
    window.__djHowtoInit = true;

    var SEL = 'dialog.dj-howto__dialog';

    function embedSrc(id) {
      return 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0&modestbranding=1&playsinline=1';
    }

    function show(dlg, id, title, credit) {
      var frame = dlg.querySelector('[data-dj-howto-iframe]');
      var heading = dlg.querySelector('[data-dj-howto-title]');
      var creditEl = dlg.querySelector('[data-dj-howto-credit]');
      if (heading && title) heading.textContent = title;
      if (creditEl) creditEl.textContent = credit || '';
      if (frame) {
        frame.title = title || '';
        // YouTube's player grabs focus on autoplay, which would swallow the Esc key; hand focus
        // back to the Close button once the embed has loaded so Esc/Tab work from the start.
        frame.addEventListener('load', function onLoad() {
          frame.removeEventListener('load', onLoad);
          setTimeout(function () {
            var closeBtn = dlg.querySelector('[data-dj-howto-close]');
            if (closeBtn && dlg.open) closeBtn.focus();
          }, 250);
        });
        frame.src = embedSrc(id);
      }
      if (!dlg.open) dlg.showModal();
    }

    function hide(dlg) {
      var frame = dlg.querySelector('[data-dj-howto-iframe]');
      if (frame) frame.removeAttribute('src');
      if (dlg.open) dlg.close();
    }

    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-dj-howto-open]');
      if (opener) {
        var dlg = document.getElementById(opener.getAttribute('aria-controls'));
        if (!dlg || typeof dlg.showModal !== 'function') return; // no <dialog> support: follow the YouTube link
        e.preventDefault();
        show(dlg, opener.dataset.video, opener.dataset.title, opener.dataset.credit);
        return;
      }
      var pick = e.target.closest('[data-dj-howto-pick]');
      if (pick) {
        var d = pick.closest(SEL);
        if (!d) return;
        show(d, pick.dataset.video, pick.dataset.title, pick.dataset.credit);
        d.querySelectorAll('[data-dj-howto-pick]').forEach(function (b) {
          b.setAttribute('aria-current', b === pick ? 'true' : 'false');
        });
        return;
      }
      var closer = e.target.closest('[data-dj-howto-close]');
      if (closer) {
        var c = closer.closest(SEL);
        if (c) hide(c);
        return;
      }
      // Click on the backdrop (the dialog element itself, outside the panel) closes.
      if (e.target.matches && e.target.matches(SEL)) hide(e.target);
    });

    // Esc / programmatic close: stop the video by dropping the iframe src.
    document.addEventListener('close', function (e) {
      if (e.target && e.target.matches && e.target.matches(SEL)) {
        var frame = e.target.querySelector('[data-dj-howto-iframe]');
        if (frame) frame.removeAttribute('src');
      }
    }, true);
  })();
  } catch(e) { console.error(e); }
})();

})();
